import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App'
import WebServices from './WebServices';
import 'text-encoding-polyfill';


window.WebServices = new WebServices();

const runtimeConfig = window.RUNTIME_CONFIG || {};
window.runtimeConfig = runtimeConfig;


const urlParams = new URLSearchParams(window.location.search);
const authID = urlParams.get('AuthID');
var host = window.location.hostname;

if(host === 'localhost' && !!authID)
{
    document.cookie = `AuthID=${authID}`

}

ReactDOM.render(
    <App />,
    document.querySelector('#root')
);